import { DoorPoint } from "./DoorPoint";
import { DoorType } from "./DoorType";
import { ModificationPointType } from "../ui/ModificationPointType";

export class DoorOpening {
  doorType: DoorType;
  topLeft: DoorPoint;
  topRight: DoorPoint;
  bottomLeft: DoorPoint;
  bottomRight: DoorPoint;
  chamferEdgeLeft?: DoorPoint;
  chamferEdgeRight?: DoorPoint;
  archEdgeLeft?: DoorPoint;

  constructor(
    doorType: DoorType,
    topLeft: DoorPoint,
    topRight: DoorPoint,
    bottomLeft: DoorPoint,
    bottomRight: DoorPoint,
    chamferEdgeLeft?: DoorPoint,
    chamferEdgeRight?: DoorPoint,
    archEdgeLeft?: DoorPoint
  ) {
    this.doorType = doorType;
    this.topLeft = topLeft;
    this.topRight = topRight;
    this.bottomLeft = bottomLeft;
    this.bottomRight = bottomRight;
    this.chamferEdgeLeft = chamferEdgeLeft;
    this.chamferEdgeRight = chamferEdgeRight;
    this.archEdgeLeft = archEdgeLeft;
  }

  public static getDoorPoint(doorOpening: DoorOpening,
    modificationPointType: ModificationPointType
  ): DoorPoint {
    switch (modificationPointType) {
      case ModificationPointType.TopLeft:
        return doorOpening.topLeft;
      case ModificationPointType.TopRight:
        return doorOpening.topRight;
      case ModificationPointType.BottomLeft:
        return doorOpening.bottomLeft;
      case ModificationPointType.BottomRight:
        return doorOpening.bottomRight;
      case ModificationPointType.ChamferEdgeLeft:
        return doorOpening.chamferEdgeLeft;
      case ModificationPointType.ChamferEdgeRight:
        return doorOpening.chamferEdgeRight;
      case ModificationPointType.ArchEdgeLeft:
        return doorOpening.archEdgeLeft;
    }
  }
}
